var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import Modal from "../../UI/Modal/Modal";
import ModalHeader from "../../UI/Modal/ModalHeader";
import useService from "../../Hooks/useService";
import { AlertInfo } from "../../UI/StandardAlerts/StandardAlerts";
import ServiceResult from "../../UI/ServiceResult/ServiceResult";
import PopulationService from "../../../Services/Population.service";
import PersonPopulationMembersTable from "./PersonPopulationMembersTable";
import useCurrentApiUser from "../../Hooks/useCurrentApiUser";
import ListService from "../../../Services/Shared/List.service";
const PopulationLookupModal = (_a) => {
    var { populationAdHocCaseloads, population } = _a, modalProps = __rest(_a, ["populationAdHocCaseloads", "population"]);
    const currentUser = useCurrentApiUser();
    const [populationState, loadPopulation] = useService(PopulationService.get);
    const [populationCountState, loadPopulationCount] = useService(PopulationService.countForPersonPopulation);
    const isTemp = !ListService.isEmptyArray(populationAdHocCaseloads);
    React.useEffect(() => {
        if (modalProps.isOpen && (population === null || population === void 0 ? void 0 : population.id)) {
            const populationId = !isTemp && population.adHoc ? population.parentId : population.id;
            loadPopulation(populationId);
            loadPopulationCount(populationId, {
                tempVals: isTemp
                    ? {
                        inPersonsCaseload: populationAdHocCaseloads === null || populationAdHocCaseloads === void 0 ? void 0 : populationAdHocCaseloads.map((person) => person.personId),
                    }
                    : {},
            });
        }
    }, [
        loadPopulation,
        loadPopulationCount,
        modalProps.isOpen,
        population.id,
        population.adHoc,
        population.parentId,
        isTemp,
        populationAdHocCaseloads,
    ]);
    return (_jsxs(Modal, Object.assign({ size: "xl" }, modalProps, { children: [_jsx(ModalHeader, { title: populationState.data && populationCountState.data != null
                    ? `${populationState.data.name} (${populationCountState.data})`
                    : "" }), _jsx("div", { className: "modal-body", children: _jsx(ServiceResult, { state: populationCountState, children: (studentCount) => studentCount > 0 && (currentUser === null || currentUser === void 0 ? void 0 : currentUser.id) ? (_jsx(PersonPopulationMembersTable, { populationId: population.id, studentTempVals: isTemp
                            ? {
                                inPersonsCaseload: populationAdHocCaseloads === null || populationAdHocCaseloads === void 0 ? void 0 : populationAdHocCaseloads.map((person) => person.personId),
                            }
                            : {} })) : (_jsx(AlertInfo, { message: "No people in this filter" })) }) })] })));
};
export default PopulationLookupModal;
